import { useCallback, useRef, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * In-App-Ersatz für window.confirm – native Dialoge werden auf Mobilgeräten
 * (Home-Screen-App, In-App-Browser, „Dialoge unterdrücken“) teils still mit
 * false beantwortet. Nutzung: const [confirm, confirmDialog] = useConfirm();
 * if (!(await confirm({ title, description }))) return;  …  {confirmDialog}
 */
export default function useConfirm() {
  const [opts, setOpts] = useState(null);
  const resolver = useRef(null);

  const confirm = useCallback((options) => new Promise((resolve) => {
    resolver.current = resolve;
    setOpts(options);
  }), []);

  const close = (result) => {
    resolver.current?.(result);
    resolver.current = null;
    setOpts(null);
  };

  const dialog = (
    <AlertDialog open={!!opts} onOpenChange={(open) => { if (!open) close(false); }}>
      <AlertDialogContent className="bg-white w-[calc(100%-2rem)] max-w-md rounded-xl" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">{opts?.title}</AlertDialogTitle>
          {opts?.description && (
            <AlertDialogDescription className="whitespace-pre-line text-[#5C6B5D]">
              {opts.description}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-0">
          <AlertDialogCancel className="mt-0 min-h-[44px] sm:min-h-0" data-testid="confirm-cancel-btn">
            Abbrechen
          </AlertDialogCancel>
          <AlertDialogAction
            className="min-h-[44px] sm:min-h-0 bg-[#B85C38] hover:bg-[#7A2E14] text-white"
            onClick={() => close(true)}
            data-testid="confirm-ok-btn"
          >
            {opts?.confirmLabel || "Löschen"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return [confirm, dialog];
}
